"use client";
import CommonImage from "@/components/common/image/CommonImage";
import SkeletonFeaturedSection from "@/components/common/skeletons/SkeletonFeaturedSection";
import HomePageService from "@/services/api/HomeService";
import { Empty } from "antd";
import { useEffect, useState } from "react";

export default function FeaturedSection() {
  const [features, setfeatures] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedImage, setSelectedImage] = useState(
    "/images/home-page/features-details.avif"
  );
  const [selectedFeatureId, setSelectedFeatureId] = useState(null);
  // console.log("selectedImage", selectedImage);
  // console.log("features", features);
  const fetchfeatures = async () => {
    setLoading(true);
    try {
      const response = await HomePageService.getServices();
      if (response) {
        setfeatures(response);
        if (response.length > 0 && response[0].image_url) {
          setSelectedImage(response[0].image_url);
          setSelectedFeatureId(response[0].id);
        }
      }
    } catch (error) {
      console.error("Error fetching features:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchfeatures();
  }, []);

  return (
    <>
      {/* {loading ? (
        <SkeletonFeaturedSection />
      ) : ( */}
        <section className="features_section section_padding bg-pattern">
          <div className="container">
            <div className="grid grid-cols-12 gap-6 items-center xl:items-start">
              <div className="lg:col-span-6 col-span-12">
                <div className="features-list-part">
                  {features?.length > 0 ? (
                    <>
                      <h2 className="main-title">
                        <span className="text-light">ফোকাস একাডেমিক</span>{" "}
                        প্রোগ্রামে যা যা থাকছে
                      </h2>
                      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                        {features?.map((feature, index) => (
                          <a
                            href="#"
                            key={index}
                            className={`feature-item ${
                              selectedFeatureId === feature.id ? "active" : ""
                            }`}
                            onClick={(e) => {
                              e.preventDefault();
                              setSelectedImage(feature.image_url);
                              setSelectedFeatureId(feature.id);
                            }}
                          >
                            <div className="item-link">
                              <span>
                                <CommonImage
                                  src={feature?.icon_url}
                                  className="img-icon"
                                  alt={feature?.title || "Image"}
                                />
                              </span>
                              <span>{feature?.title}</span>
                            </div>
                          </a>
                        ))}
                      </div>{" "}
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              {features?.length > 0 && (
                <div className="lg:col-span-6 col-span-12 hidden lg:block">
                  <div className="feature-img-part">
                    {selectedImage && (
                      <CommonImage src={selectedImage} alt={"Feature Image"} />
                    )}
                  </div>
                </div>
              )}
            </div>
          </div>
        </section>
      {/* )} */}
    </>
  );
}
